import React from 'react'

import { Row } from 'antd'

// The page's own ground, with the bar on top of it and the content column beneath.
// The bar is passed in as `top` and rendered OUTSIDE the centred column on purpose: a
// sticky bar that spans the page cannot live inside a max-width column (standard, part 3).
// 🔴 AND THE ABSTRACT LAYER. Measured in a real browser on 19 Sep 2026: NINE of the ten sites
// painted a soft gradient wash and nothing else, while nodejavascript.com painted a masked grid.
// George, that evening, verbatim: *"the only thing wrong is that the background image is not
// there for all sites except nodejavascript … the rest of the sites have lovely theme colors and
// gradients, but maybe missing the extra touch of a background abstract."* Every site gets its
// own geometry; this one is written below in the stylesheet.
const Background = ({ children, top }) => (
  <div className='dvs-bg'>
    <div className='dvs-pattern' aria-hidden='true' />
    {top}
    <Row align='center' className='dvs-shell'>
      {children}
    </Row>
  </div>
)

export default Background
